import React ,{useRef} from "react";
import TrackVisibility from "react-on-screen";
import CountUp from "react-countup";
import { Link } from "react-router-dom";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger, SplitText } from "gsap/all";
gsap.registerPlugin(ScrollTrigger, SplitText);
const AboutTwo = () => {

   const container = useRef();
  useGSAP(
    () => {

      // let split = SplitText.create(".content_para_animation", {
      //   type: "words,chars,lines",
      // });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container.current,
          start: "top+=250 bottom",
          end: "bottom",
          // markers: true
        },
      });
      
       tl.fromTo(
          ".aboutpage_heading_animation",
          { opacity: 0, y: 60 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            stagger: 0.1,
            // ease: 'power3.out',
            // stagger: 0.4 // Adjust this value for the desired stagger effect
          }
        ).fromTo(
          ".aboutpage__image_animation",
          { opacity: 0, y: 100 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
            stagger: 0.2,
            
            // ease: 'power3.out',
            // stagger: 0.4 // Adjust this value for the desired stagger effect
          }, "0"
        )
      return () => {
        tl.kill();
      };
    },
    { scope: container },
  );
  return (
    <div className="space">
      <div className="container" ref={container}>
        <div className="row align-items-center">
          <div className="col-xl-6">
            <div className="title-area mb-30">
              <span className="sub-title aboutpage_heading_animation">
                <img src="/assets/img/icon/title_left.svg" alt="shape" />
                About Us
              </span>
              <h2 className="sec-title style2 aboutpage_heading_animation">
               Who we are?
              </h2>
              <p className="sec-text aboutpage_heading_animation">
                Meridian Consulting is a global IT consulting service provider
                that focuses on delivering high value through reliable,
                integrated, responsive, and cost-effective solutions. From small
                and medium to large companies, we have offered our expertise to
                enable businesses in overcoming IT-related business challenges.
              </p>
                <p className="sec-text aboutpage_heading_animation">
                With our cutting edge services, clients are offered dynamic,
                resilient, and scalable options to ensure rapid growth. We
                integrate emerging technologies to offer solutions for complex
                IT projects.
              </p> 
               <p className="sec-text aboutpage_heading_animation">
  Our team of experienced professionals is committed to delivering
  innovative and customized solutions tailored to each client’s unique
  needs. By combining industry best practices with a client-centric
  approach, Meridian Consulting ensures seamless execution, enhanced
  performance, and long-term business success in an ever-evolving
  digital landscape.
</p>
            </div>
           
            <div className="btn-group aboutpage_heading_animation">
              <Link to="/about" className="global-btn style2">
                Explore More{" "}
                <img src="/assets/img/icon/right-icon.svg" alt="Bizmaster" />
              </Link>
            </div>
          </div>
          <div className="col-xl-6">
            <div className="about-thumb2">
              <div className="about-img-1 ">
                <img src="/assets/img/normal/about_2-1.png" alt="img" className="aboutpage__image_animation" />
              </div>
              <div className="about-img-2">
                <img src="/assets/img/normal/about_2-2.png" alt="img" className="aboutpage__image_animation"/>
              </div>
              {/* <div className="about-img-2">
                <img src="/assets/img/normal/about_2-2.png" alt="img" />
              </div> */}
              {/* <div className="about-counter-wrap">
                <div className="about-icon">
                  <img src="/assets/img/icon/about_icon2-1.svg" alt="img" />
                  <div>
                    <h3 className="about-counter">
                      <TrackVisibility once>
                        {({ isVisible }) =>
                          isVisible && (
                            <span className="counter-number">
                              <CountUp delay={0} start={0} end={6} />
                              k+
                            </span>
                          )
                        }
                      </TrackVisibility>
                    </h3>
                    <h4 className="about-counter-text">Clients</h4>
                  </div>
                </div>
                <p className="sec-desc">
                  Lorem Ipsum is simply dummy text of the
                </p>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutTwo;
